
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

function Toast() {
    return (
        <ToastContainer
            position="bottom-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            toastStyle={{backgroundColor: '#333'}}
            theme="dark" />
    )
}

export default Toast;